import React from 'react';
import Icon from '@amzn/meridian/icon';
import closeSmallTokens from '@amzn/meridian-tokens/base/icon/close-small';
import Tooltip from '@amzn/meridian/tooltip';

interface NoXProps {
  className?: string;
  tooltip: string;
}

const NoX = ({ className, tooltip }: NoXProps) => (
  <Tooltip position='top' title={tooltip}>
    <Icon className={className} tokens={closeSmallTokens} />
  </Tooltip>
);

export default NoX;
